import { handleWhell, isHorizontalScrollable, isVerticalScrollable } from "../scroll";

import { IconFuncTypeEnum } from "../../ts-types";

export function bindTouchListener(eventManager) {
    const table = eventManager.table, stateManager = table.stateManager, scenegraph = table.scenegraph;
    eventManager.touchMovePoints = [], table.scenegraph.tableGroup.addEventListener("touchstart", (e => {
        e.target.isChildOf(scenegraph.component.vScrollBar) || e.target.isChildOf(scenegraph.component.vScrollBar) || (eventManager.isTouchdown = !0, 
        eventManager.touchMovePoints.push({
            x: e.page.x,
            y: e.page.y,
            timestamp: Date.now()
        }));
    }));
    const globalTouchMoveCallback = e => {
        var _a, _b;
        if (eventManager.touchMove && e.preventDefault(), eventManager.isTouchdown && isTouchEvent(e)) if ((null === (_b = null === (_a = eventManager.downIcon) || void 0 === _a ? void 0 : _a.attribute) || void 0 === _b ? void 0 : _b.funcType) === IconFuncTypeEnum.dragReorder) e.preventDefault(); else if (eventManager.touchMovePoints.length > 4 && eventManager.touchMovePoints.shift(), 
        eventManager.touchMovePoints.push({
            x: e.changedTouches[0].pageX,
            y: e.changedTouches[0].pageY,
            timestamp: Date.now()
        }), eventManager._enableTableScroll) {
            const deltaX = -eventManager.touchMovePoints[eventManager.touchMovePoints.length - 1].x + eventManager.touchMovePoints[eventManager.touchMovePoints.length - 2].x, deltaY = -eventManager.touchMovePoints[eventManager.touchMovePoints.length - 1].y + eventManager.touchMovePoints[eventManager.touchMovePoints.length - 2].y;
            handleWhell({
                deltaX: deltaX,
                deltaY: deltaY
            }, stateManager), e.cancelable && ("none" === table.internalProps.overscrollBehavior || Math.abs(deltaY) >= Math.abs(deltaX) && 0 !== deltaY && isVerticalScrollable(deltaY, stateManager) || Math.abs(deltaY) <= Math.abs(deltaX) && 0 !== deltaX && isHorizontalScrollable(deltaX, stateManager)) && e.preventDefault();
        }
    };
    window.addEventListener("touchmove", globalTouchMoveCallback, {
        passive: !1
    }), eventManager.globalEventListeners.push({
        name: "touchmove",
        env: "window",
        callback: globalTouchMoveCallback
    });
    const globalTouchEndCallback = e => {
        var _a, _b, _c, _d;
        if (eventManager.touchEnd = !0, eventManager.touchMove = !1, eventManager.isTouchdown && isTouchEvent(e)) {
            if ((null === (_b = null === (_a = eventManager.downIcon) || void 0 === _a ? void 0 : _a.attribute) || void 0 === _b ? void 0 : _b.funcType) === IconFuncTypeEnum.dragReorder) e.preventDefault(); else if ((null === (_c = eventManager.touchMovePoints) || void 0 === _c ? void 0 : _c.length) && (eventManager.touchMovePoints.length > 4 && eventManager.touchMovePoints.shift(), 
            eventManager.touchMovePoints.push({
                x: e.changedTouches[0].pageX,
                y: e.changedTouches[0].pageY,
                timestamp: Date.now()
            }), eventManager._enableTableScroll)) {
                const firstPoint = eventManager.touchMovePoints[0], lastPoint = eventManager.touchMovePoints[(null === (_d = eventManager.touchMovePoints) || void 0 === _d ? void 0 : _d.length) - 1], vX = (lastPoint.x - firstPoint.x) / (lastPoint.timestamp - firstPoint.timestamp), vY = (lastPoint.y - firstPoint.y) / (lastPoint.timestamp - firstPoint.timestamp);
                eventManager.inertiaScroll.startInertia(vX, vY, .95), table.eventManager.inertiaScroll.setScrollHandle(((dx, dy) => {
                    handleWhell({
                        deltaX: -dx,
                        deltaY: -dy
                    }, table.stateManager);
                }));
            }
            eventManager.isTouchdown = !1, eventManager.touchMovePoints = [];
        }
    };
    window.addEventListener("touchend", globalTouchEndCallback), eventManager.globalEventListeners.push({
        name: "touchend",
        env: "window",
        callback: globalTouchEndCallback
    });
    const globalTouchCancelCallback = e => {
        eventManager.touchEnd = !0, eventManager.touchMove = !1, eventManager.isTouchdown && (eventManager.isTouchdown = !1, 
        eventManager.touchMovePoints = []);
    };
    window.addEventListener("touchcancel", globalTouchCancelCallback), eventManager.globalEventListeners.push({
        name: "touchcancel",
        env: "window",
        callback: globalTouchCancelCallback
    });
}

function isTouchEvent(e) {
    return !!e.changedTouches;
}
//# sourceMappingURL=touch.js.map
